import React, { useState } from 'react';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav>
      <a href="#" className="nav-logo">
        <div className="nav-logo-mark">
          <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
            <path d="M3 9C3 5.686 5.686 3 9 3" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
            <path d="M15 9C15 12.314 12.314 15 9 15" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
            <circle cx="9" cy="9" r="2.5" fill="#fff"/>
            <path d="M9 3V1M9 17v-2M3 9H1M17 9h-2" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </div>
        SortMyBusiness<span>AI</span>
      </a>
      <ul className="nav-links">
        <li><a href="#problems">Your Problems</a></li>
        <li><a href="#before-after">Before &amp; After</a></li>
        <li><a href="#how">How It Works</a></li>
        <li><a href="#savings">The Numbers</a></li>
      </ul>
      <a href="#cta" className="btn btn-solid nav-cta">Get My Free Plan &rarr;</a>

      <button className="nav-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
        <span /><span /><span />
      </button>
      <div className={`nav-mobile-menu ${menuOpen ? 'open' : ''}`}>
        <a href="#problems" onClick={() => setMenuOpen(false)}>Your Problems</a>
        <a href="#before-after" onClick={() => setMenuOpen(false)}>Before &amp; After</a>
        <a href="#how" onClick={() => setMenuOpen(false)}>How It Works</a>
        <a href="#savings" onClick={() => setMenuOpen(false)}>The Numbers</a>
        <a href="#cta" className="btn btn-solid" onClick={() => setMenuOpen(false)} style={{ textAlign: 'center', marginTop: '1rem' }}>Get My Free Plan &rarr;</a>
      </div>
    </nav>
  );
};

export default Navbar;
